import React, { Component } from "react";
import { connect } from "react-redux";

import Header from "./Common/Header";
import * as actions from "../actions";
import "../css/site.css";
import Sidebar from "./Common/sidebar";
import Footer from "./Common/Footer/Footer";

class App extends Component {
  componentDidMount() {
    this.props.checkAuth();
  }
  constructor(props) {
    super(props);
    this.state = {
      activeSidebar: true
    };
  }

  toggleSideBar = event => {
    this.setState(() => {
      return {
        activeSidebar: !this.state.activeSidebar
      };
    });
  };

  render() {
    const { isAuthenticated, role } = this.props.authentication;
    return [
      <Header toggleSideBar={this.toggleSideBar} />,
      <Footer />,
      <div className="wrapper d-flex" >
        {isAuthenticated && (
          <Sidebar activeSidebar={this.state.activeSidebar} userRole={role} />
        )}
        <div className="container-fluid px-lg-5 px-3 mt-md-5 mt-4 pt-5" id="content">
          {this.props.children}
        </div>
      </div>
    ];
  }
}

function mapStateToProps(state) {
  return {
    authentication: state.auth,
  };
}

export default connect(mapStateToProps, actions)(App);
